import { Component } from "react";
import setupCookie from "./setupCookie";

class AISearchMvt extends Component {
  componentDidMount() {
    setupCookie();
  }

  render() {
    return null;
  }
}

export default AISearchMvt;
